module.exports = ["Unhappy","Unhappy","Neutral","Happy","Happy"]


//////////////////
// WEBPACK FOOTER
// ./src/data/happiness.yaml
// module id = 744
// module chunks = 168707334958949